import { render } from "./Home.vue?vue&type=template&id=56210585&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=56210585&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56210585"],['__file',"src/views/pre/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56210585"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56210585', __exports__)) {
    console.log('reload')
    api.reload('56210585', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=56210585&scoped=true", () => {
    console.log('re-render')
    api.rerender('56210585', render)
  })

}


export default __exports__